
















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { StripInputOption } from '@/entities/survey'

@Component<StripInput>({
    model: {
        prop: 'value',
        event: 'change'
    }
})
export default class StripInput extends Vue {
    // if (isMultiSelect===true), return value:string[]
    // else return value:string
    @Prop({ required: true, default: null }) public value!: string | string[]
    @Prop({ required: false, default: '' }) public label!: string
    @Prop({ required: true, default: null }) public options!: StripInputOption[]
    @Prop({ required: false, default: false }) public isMultiSelect!: boolean
    @Prop({ required: false, default: false }) public disabled!: boolean

    public clickHandler(option: StripInputOption, index: string) {
        if (!this.isMultiSelect) {
            this.options.forEach(e => (e.selected = e.value === option.value))
            return this.$emit('change', option.value)
        }
        this.options[index].selected = !this.options[index].selected
        const value = this.options.filter(e => e.selected).map(e => e.value)
        this.$emit('change', value)
    }
}
